import data from './attrs/data'
import methods from './attrs/methods'

import AgencyProfile from './components/AgencyProfile/Index'
import CustomerProfile from './components/CustomerProfile/Index'

export default {
    name: "Profile",
    data,
    methods,
    components: {
        AgencyProfile,
        CustomerProfile
    }
}
